import React from 'react';
import { updateBranch, updateResponse, getClubs, getBranch } from "../../api/branchapi";
import { getTimeZones } from "../../api/timeZoneApi";
import {
    Form,
    Label, Input,
    Button, Col, Row,
} from 'reactstrap';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import CustomDatePicker from '../CustomDatePicker';
import { formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers';
import { getPermission } from '../../api/userapi';
import PopupError from '../PopupError';
import CardTitle from '../CardTitle';
import FormValidator from '../FormValidation';
import cloneDeep from 'lodash/cloneDeep';
import '../css/EditCreate.css';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';

class BranchEdit extends React.Component {

    constructor(props) {
        super(props);
        this.permission = getPermission()
        if (this.props.route.location.state) {
            if (this.props.route.location.state.from === 'view') {
                this.props.route.history.push('/secure/branches');
                this.props.route.history.push(this.props.route.match.url);
            }
            if (this.props.route.location.state.from === 'products') {
                this.props.route.history.push(`/secure/products`);
                this.props.route.history.push(this.props.route.match.url);
            }
            if (this.props.route.location.state.from === 'locations') {
                this.props.route.history.push(`/secure/locations`);
                this.props.route.history.push(this.props.route.match.url);
            }

        }

        this.validator = new FormValidator([
            {
                field: 'name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchCode',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchCode',
                method: 'isNumeric',
                validWhen: true,
                message: 'Value must be a number.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            {
                field: 'customerServiceEmail',
                method: (fieldValue) => {
                    if (fieldValue.trim() === '') {
                        return false
                    }

                    return this.isEmail(fieldValue);
                },
                validWhen: false,
                message: 'Please enter valid emails.'
            },
            {
                field: 'branchTerms',
                method: (fieldValue) => (fieldValue || '').length <= 255,
                validWhen: true,
                message: 'The maximum length is 255 characters.'
            }
        ]);
        let branch = null;
        if (this.props.route.location.branch)
            if (this.props.route.location.state.branch)
                branch = this.props.route.location.state.branch;

        this.state = {
            readOnly: true,
            branch: branch,
            cancel: false,
            saved: false,
            error: false,
            edit: false,
            validation: this.validator.valid(),
            baseState: '',
            systemTimeZoneName: '',
            clubs: [],
            timeZones: [],
            errorMessage: [],
            _startDate: '',
            _endDate: '',
            branchId: this.props.route.match.params.id,
            branchTerms: ''

        };
        this.closeModal = this.closeModal.bind(this);
    }
    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);
    isEmail = (state) => {
        return (!state.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(;[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/));
    }

    //Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true,
        }));
    }

    componentDidMount() {

        this.props.getClubs(function (result, _this) { _this.getData(result, _this) }, this);
        this.props.getTimeZones(function (result, _this) { _this.getDataTimeZones(result, _this) }, this);

        if (this.state.branch == null) {
            const branchId = this.props.route.match.params.id;
            this.props.getBranch(function (result, _this) { _this.getDataBranch(result, _this) }, this, branchId)
        } else if (this.props.route.location.state.branch) {
            var x = JSON.stringify(cloneDeep(this.props.route.location.state.branch));
            this.setState({
                baseState: x,
            });
            this.state._startDate = !this.state.branch.startDate ? '' : formatInTimeZoneDate(this.state.branch.startDate, this.state.branch.branchIanaTimeZoneId)
            this.state._endDate = !this.state.branch.endDate ? '' : formatInTimeZoneDate(this.state.branch.endDate, this.state.branch.branchIanaTimeZoneId)
        }
    }

    getDataBranch(data, _this) {
        var x = JSON.stringify(cloneDeep(data.data.data))
        _this.setState({
            branch: data.data.data,
            baseState: x,
            branchIanaTimeZoneId: data.data.data.branchIanaTimeZoneId,
            _startDate: !data.data.data.startDate ? '' : formatInTimeZoneDate(data.data.data.startDate, data.data.data.branchIanaTimeZoneId),
            _endDate: !data.data.data.endDate ? '' : formatInTimeZoneDate(data.data.data.endDate, data.data.data.branchIanaTimeZoneId),
            branchTerms: !data.data.data.branchTerms ?? ''
        })
    }

    //Resets view to previous state, goes back to view club
    handleCancel = () => {
        console.log(this.state.baseState);
        if (this.state.edit) {
            this.setState(state => ({
                readOnly: true,
                branch: JSON.parse(state.baseState),
                edit: false,
                //sets validation to previous state
                validation: this.validator.valid()
            }))

            document.getElementById("startDate").value = !this.state.branch.startDate ? "" : this.state.branch.startDate.substring(0, 10);
            document.getElementById("endDate").value = !this.state.branch.endDate ? "" : this.state.branch.endDate.substring(0, 10);
            this.submitted = false;
            //Removes the is-invalid class from all inputs when editing is canceled
            var els = document.getElementsByClassName('is-invalid')
            while (els[0]) {
                els[0].classList.remove('is-invalid')
            }

        } else {
            console.log("cancel")
            this.setState({
                cancel: true
            })
        }
    }

    renderTimeZones() {
        let timeZones = this.state.timeZones;
        return timeZones.map((timeZone, index) => {
            if (timeZone.name === this.state.branch.systemTimeZoneName) {
                var selected = true;
            }
            return (
                <option id={timeZone.systemTimeZoneId} key={index} defaultValue={selected}>{timeZone.name}</option>
            );
        });
    }

    renderClubNames() {
        let clubs = this.state.clubs;
        return clubs.map((club, index) => {
            if (clubs.name === this.state.branch.clubName) {
                var selected = true;
            }
            return (
                <option id={club.clubId} key={index} defaultValue={selected}>{club.name}</option>
            );
        });
    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        console.log(this.state.branch);
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    var x = JSON.stringify(cloneDeep(this.state.branch));
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        readOnly: !state.readOnly,
                        validation: this.validator.valid(),
                        _startDate: !state.branch.startDate ? '' : formatInTimeZoneDate(state.branch.startDate + "T00:00:00", state.branchIanaTimeZoneId),
                        _endDate: !state.branch.endDate ? '' : formatInTimeZoneDate(state.branch.endDate + "T00:00:00", state.branchIanaTimeZoneId)
                    }));

                    //When saving is success, it brings the saved results again for updating footer.
                    this.props.getBranch(function (result, _this) { _this.getDataBranch(result, _this) }, this, this.state.branch.branchId)

                } else if (result.data.success === false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                }
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    getDataTimeZones(data, _this) {
        //Unshift adds an empty value to the start of the array, for creating an empty <option> tag
        let timeZones = data.data.data;
        timeZones.unshift("");

        _this.setState({
            timeZones: timeZones,
            loading: false
        })
    }

    getData(data, _this) {
        _this.setState({
            clubs: data.data.data,
            loading: false
        })
    }

    //Calls API for updating branch on form submit
    handleSubmit = event => {
        event.preventDefault();

        var updVal = this.state.branch;
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        updVal.branchTerms = (updVal.branchTerms || '').trim() || null;
        this.setState({ branch: updVal }, () => {
            const validation = this.validator.validate(this.state.branch);
            this.setState({ validation });
            if (validation.isValid) {
                // handle actual form submission here
                this.props.updateBranch(updVal);
            }
        });
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }
    changeSaleTaxRate = e => {
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,4})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;
        this.state.branch.saleTaxRate = value;
        if (val.length > 0) {
            e.target.value = Number(value).toFixed(4);
            this.state.branch.saleTaxRate = Number(value).toFixed(4);
        }
    }
    render() {
        const branch = this.state.branch
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/branches`,
                }}
            />;
        }
        let validation = this.submitted ?
            this.validator.validate(this.state.branch) :
            this.state.validation;

        return (
            <div className="card">

                <CardTitle
                    component={"Branch"}
                    readOnly={this.state.readOnly} />

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage}
                />

                <div className="card-body fs-12">
                    {branch && <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Col className={`${validation.name.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                    <Label htmlFor='name' className="required-hint mt-4"><strong>Branch</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="name"
                                        type="input"
                                        name="name"
                                        maxLength="150"
                                        value={branch.name}
                                        autoComplete="off"
                                        // required
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        onChange={(e) => { this.isInvalid(e); var x = branch; x.name = e.target.value; this.setState({ branch: x }) }} />
                                    <span className="help-block">{validation.name.message}</span>
                                </Col>
                                <Col className={`${validation.branchCode.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                    <Label htmlFor='branchCode' className="required-hint mt-4"><strong>Branch code</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        type="number"
                                        name="branchCode"
                                        id='branchCode'
                                        value={branch.branchCode}
                                        // required
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        onChange={(e) => { this.isInvalid(e); var x = branch; x.branchCode = e.target.value; this.setState({ branch: x }) }} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.numericValue} id='branchCode' />}
                                    <span className="help-block">{validation.name.message}</span>
                                </Col>
                                <Row>
                                    <div className="col-md-12">
                                        <Col >
                                            <Label htmlFor='saleTaxRate' className="mt-4"><strong>Sale Tax Rate</strong><span> (enter values ​​greater than 0 up to 1, for example, 6% as 0.06, 5.5% as 0.055.)</span></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="number"
                                                maxLength="20"
                                                name="saleTaxRate"
                                                id='saleTaxRate'
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                value={branch.saleTaxRate}
                                                onBlur={(e) => { this.changeSaleTaxRate(e) }}
                                                onChange={(e) => { this.isInvalid(e); var x = branch; x.saleTaxRate = e.target.value; this.setState({ branch: x }) }} />
                                            {!this.state.readOnly && <InputFeedback feedbackText={feedback.numericValue} id='saleTaxRate' />}
                                            <span className="help-block">{validation.name.message}</span>
                                        </Col>
                                    </div>
                                </Row>
                                {!this.state.readOnly && <Row>
                                    <div className='col-md-6'>
                                        <Col className={`${validation.startDate.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!this.state.branch.startDate ? "" : formatInTimeZoneDate(this.state.branch.startDate, this.state.branchIanaTimeZoneId).substring(0, 10)}
                                                label="Start Date"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                    </div>
                                    <div className='col-md-6'>
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!this.state.branch.endDate ? "" : formatInTimeZoneDate(this.state.branch.endDate, this.state.branchIanaTimeZoneId).substring(0, 10)}
                                                label="End Date"
                                            />
                                        </Col>
                                    </div>
                                </Row>}

                                {this.state.readOnly && <div className="col-md-12">
                                    <Row>
                                        <div className={this.state.readOnly ? 'col-md-6 _startDate ' : "col-md-6 hide"}>
                                            <Label htmlFor='_startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <Input
                                                id="_startDate"
                                                readOnly={true}
                                                className=''
                                                value={this.state._startDate}>
                                            </Input>

                                        </div>
                                        <div className={this.state.readOnly ? 'col-md-6 _endDate' : "col-md-6 hide"}>
                                            <Label htmlFor='_endDate' className="mt-4"><strong>End date</strong></Label>
                                            <Input
                                                id="_endDate"
                                                readOnly={true}
                                                className=''
                                                value={this.state._endDate}>
                                            </Input>
                                        </div>
                                    </Row>
                                </div>}
                            </div>

                            <div className="col-md-6">
                                <Col>
                                    <Label htmlFor='clubName' className="required-hint mt-4" ><strong>Club</strong></Label>
                                    <label className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                        <select
                                            id="clubName"
                                            name="clubName"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                            disabled={this.state.readOnly} value={branch.clubName}
                                            onChange={(e) => {
                                                var x = this.state.branch; x.clubName = e.target.value;
                                                var y = this.state.branch; y.clubId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ branch: x, branch: y })
                                            }}
                                        >
                                            {this.renderClubNames()}
                                        </select>
                                    </label>
                                </Col>
                                <Col className={`${validation.customerServiceEmail.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='email' className="mt-4"><strong>Customer Service Email</strong></Label>
                                    <Input
                                        readOnly={this.state.readOnly}
                                        type="text"
                                        maxLength="256"
                                        name="customerServiceEmail"
                                        autoComplete="off"
                                        id='email'
                                        className={this.state.readOnly ? '' : 'input-editable form-control'}
                                        value={branch.customerServiceEmail}
                                        onChange={(e) => { this.isInvalid(e); var x = branch; x.customerServiceEmail = e.target.value; this.setState({ branch: x }) }} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.email} id='email' />}
                                    <span className="help-block">{validation.customerServiceEmail.message}</span>
                                </Col>
                                <Col>
                                    <Label htmlFor='timeZone' className="required-hint mt-4" ><strong>Local time zone</strong></Label>
                                    <label className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                        <select
                                            id="timeZone"
                                            name="timeZone"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                            disabled={this.state.readOnly} value={branch.systemTimeZoneName ? branch.systemTimeZoneName : ''}
                                            onChange={(e) => {
                                                var x = this.state.branch;
                                                x.systemTimeZoneName = e.target.value;
                                                var y = this.state.branch;
                                                y.systemTimeZoneId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ branch: x, branch: y })
                                            }}
                                        >
                                            {this.renderTimeZones()}
                                        </select>
                                    </label>
                                    <Label htmlFor='branchTerms' className="mt-4"><strong>Branch Terms &amp; Conditions</strong></Label>
                                    <Input
                                        id="branchTerms"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        readOnly={this.state.readOnly}
                                        value={branch.branchTerms || ''}
                                        onChange={(e) => {
                                            var x = branch; x.branchTerms = e.target.value;
                                            this.setState({ branch: x, branchTerms: e.target.value });
                                        }}
                                        placeholder="Enter terms and conditions (max 255)"
                                    />
                                    <div className="text-right text-muted" style={{ fontSize: 12 }}>
                                        {(branch.branchTerms || '').length}/255
                                    </div>
                                    <div className="text-right float-bottom">
                                        <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                        {this.permission.isAdmin &&
                                            <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'edit-btn' : 'd-none'}>EDIT</Button>}
                                        <Button onClick={this.handleSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'save-btn'}>SAVE</Button>
                                    </div>
                                </Col>

                            </div>
                        </div>
                    </Form>
                    }
                    <Col>
                        <hr />
                    </Col>
                    {branch && <Col>
                        <Row>
                            <div className="col-md-1">
                                <div className="inline-label"><strong>ID</strong></div>
                                <p className="editFooterText">{branch.branchId}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created by</strong></div>
                                <p className="editFooterText">{branch.createdBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(branch.createdDate, branch.branchIanaTimeZoneId)}</p>
                            </div>
                            <div className="col-md-2">
                                <div className="inline-label"><strong>Updated by</strong></div>
                                <p className="editFooterText">{branch.updatedBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Updated date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(branch.updatedDate, branch.branchIanaTimeZoneId)}</p>
                            </div>
                        </Row>
                    </Col>
                    }
                </div>
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            branch: state.data.branch,
            updateResult: state.data.updateResult,
            clubs: state.data.clubs,
            timeZones: state.data.timeZones
        }
    },
    dispatch => ({
        updateBranch: (callback, conext) => { dispatch(updateBranch(callback, conext)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getClubs: (callback, context) => { dispatch(getClubs(callback, context)) },
        getTimeZones: (callback, context) => { dispatch(getTimeZones(callback, context)) },
        getBranch: (callback, context, id) => { dispatch(getBranch(callback, context, id)) }
    }
    )
)(BranchEdit);

